var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.213081 8.62641C0.0766385 8.46021 0 8.23491 0 8C0 7.76509 0.0766385 7.53979 0.213081 7.37359L6.04187 0.28213C6.10858 0.195039 6.18901 0.125186 6.27839 0.0767374C6.36776 0.0282888 6.46424 0.00223827 6.56207 0.000138283C6.6599 -0.00196266 6.75707 0.0199327 6.8478 0.0645151C6.93852 0.109097 7.02093 0.175456 7.09012 0.25963C7.15931 0.343804 7.21385 0.444071 7.25049 0.554447C7.28714 0.664824 7.30514 0.783048 7.30341 0.902069C7.30168 1.02109 7.28027 1.13847 7.24045 1.24721C7.20063 1.35594 7.14321 1.4538 7.07163 1.53496L2.48631 7.11357H16.2714C16.4646 7.11357 16.65 7.20696 16.7866 7.3732C16.9232 7.53944 17 7.7649 17 8C17 8.2351 16.9232 8.46056 16.7866 8.6268C16.65 8.79304 16.4646 8.88643 16.2714 8.88643H2.48631L7.07163 14.465C7.14321 14.5462 7.20063 14.6441 7.24045 14.7528C7.28027 14.8615 7.30168 14.9789 7.30341 15.0979C7.30514 15.217 7.28714 15.3352 7.25049 15.4456C7.21385 15.5559 7.15931 15.6562 7.09012 15.7404C7.02093 15.8245 6.93852 15.8909 6.8478 15.9355C6.75707 15.9801 6.6599 16.002 6.56207 15.9999C6.46424 15.9978 6.36776 15.9717 6.27839 15.9233C6.18901 15.8748 6.10858 15.805 6.04187 15.7179L0.213081 8.62641Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.915e7f8b85a0db05f7ef48ee76e5cc76.svg";
export { ForwardRef as ReactComponent };